import { withSyncEnterLoader } from 'util/routeHelper';
import { languageMapRoute } from 'util/i18n';

import OverviewRoute from './Overview';
import SettingsRoute from './Settings';
import WishlistRoute from './Wishlist';
import BookingRoute from './Booking';
import ReservationRoute from './ReservationRecord';
import CommunityRoute from './Community';
import InterviewRoute from './Interview';

export default store => ({
	path: 'user',
	indexRoute: {
		component: null,
		onEnter: ({ params: { lang } }, replace) => replace(`/${lang}/user/overview`),
	},
	onEnter: withSyncEnterLoader(
		(nextState, replace, updateRatio, callback) => {
			updateRatio(0.8);

			const { auth: { token: { accessToken } }, i18n: { lan } } = store.getState();

			if (accessToken === '') {
				replace({
					pathname: `/${languageMapRoute(lan)}/login`,
					state: {
						nextPathname: nextState.location.pathname,
						nextQuery: nextState.location.query,
					},
				});
			}
			callback();
		},
		store,
		'ENTER_USER',
	),
	childRoutes: [
		OverviewRoute(store),
		SettingsRoute(store),
		WishlistRoute(store),
		BookingRoute(store),
		ReservationRoute(store),
		CommunityRoute(store),
		InterviewRoute(store),
	],
});



// WEBPACK FOOTER //
// ./src/routes/User/index.js